module.exports = {"361023100":"琴城镇","361023101":"太和镇","361023102":"白舍镇","361023103":"市山镇","361023104":"洽湾镇","361023105":"桑田镇","361023106":"紫霄镇","361023200":"三溪乡","361023201":"东坪乡","361023202":"莱溪乡","361023203":"太源乡","361023204":"傅坊乡","361023400":"南丰县长红垦殖场","361023500":"南丰工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361023.json
// module id = 1331
// module chunks = 0